// extracted by mini-css-extract-plugin
export default {"CommonNotes":"CommonNotes_CommonNotes__mLSTd","MarginTop":"CommonNotes_MarginTop__0gvV7","notesStyles":"CommonNotes_notesStyles__CMkSd","boxShadow":"CommonNotes_boxShadow__qAszh"};